<template>
  <div>
    <a-card
      :bordered="false"
      class="header-solid h-full"
      :bodyStyle="{ paddingTop: 0, paddingBottom: 0 }"
      style="height: 550px"
    >
      <template #title>
        <h6 class="font-semibold m-0">Account</h6>
      </template>
      <a-descriptions class="mb-10" title="" :column="1">
        <a-descriptions-item label="">
          <p class="mt-5 mb-5 text-muted">
            MUIC Account :
            <span class="text-dark">{{ dataStudyBasic[0].student_id }}</span>
          </p>
          <p class="text-muted mt-5 mb-5 f-12">For access</p>
          <p class="text-muted mt-5 mb-0 f-12">
            <ul>
              <li>Internet Account ( @MUIC-WiFi , MU-WIFI , IC-WIFI ) , PASSWORD : YOUR MU ACCOUNT PASSWORD</li>
              <li>MY MUIC</li>
              <li>SKY SYSTEM , SKY+</li>
            </ul>
          </p>
        </a-descriptions-item>
        <a-descriptions-item label="">
          <p class="mt-5 mb-5 text-muted">E-mail :</p>
          <p class="font-semibold m-0">{{ dataStudyBasic[0].email }}</p>
          <span class="text-muted">
            <ul>
              <li>
                <p class="mt-10 mb-0 font-weight-bold text-dark">Microsoft 365 for Education Account</p>
                <p class="mt-0 mb-0 f-12">PASSWORD : YOUR MU ACCOUNT PASSWORD</p>
              </li>
              <li>
                  <p class="mt-0 mb-0 font-weight-bold text-dark">Google Apps For Education Account</p>
                <p class="mt-0 mb-0 f-12">
                    You can visit at <a href="https://accounts.google.com/" target="_blank">https://accounts.google.com/</a> to login to use Google Apps For Study in the form of title. True @ student.mahidol.edu On the part of students , after using the account for about 24 hours.
                </p>
              </li>
            </ul>
          </span>
        </a-descriptions-item>
      </a-descriptions>
    </a-card>
  </div>
</template>

<script>
export default {
  props: {
    dataStudyBasic: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.f-18 {
  font-size: 18px;
}
.f-16 {
  font-size: 16px;
}
.f-12 {
  font-size: 12px;
  font-weight: 300;
}
</style>